// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export const getA11yAttributes = _ref => {
  let {
    asLabel,
    title,
    ready,
    id
  } = _ref;
  if (!asLabel) {
    return {
      'aria-describedby': ready ? id : undefined
    };
  }
  if (typeof title === 'string') {
    return {
      'aria-label': title
    };
  }
  return {
    'aria-labelledby': ready ? id : undefined
  };
};